import { ScreenCompanyWebhook } from '@dms/screen'

export default ScreenCompanyWebhook
